import React from "react";
import PageHeader from "@/components/app/PageHeader";
import PushSettingsCard from "@/components/app/PushSettingsCard";

/**
 * Personal settings page. Currently hosts push notification preferences.
 * More user-scoped controls (email digest cadence, language, timezone) can
 * live here in the future.
 */
export default function Settings() {
  return (
    <div data-testid="settings-page">
      <PageHeader
        title="Settings"
        subtitle="Personal preferences · devices · notifications"
      />
      <div className="px-8 pb-16 max-w-3xl">
        <PushSettingsCard />
      </div>
    </div>
  );
}
